import { render, staticRenderFns } from "./FilterSideBar.vue?vue&type=template&id=2d645c11&scoped=true&"
import script from "./FilterSideBar.vue?vue&type=script&lang=js&"
export * from "./FilterSideBar.vue?vue&type=script&lang=js&"
import style0 from "./FilterSideBar.vue?vue&type=style&index=0&id=2d645c11&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d645c11",
  null
  
)

export default component.exports